export default __webpack_public_path__ + "dist/media/UserIcon.be7b48e7.svg";